import axios from "axios";

export const consultarParametrosPresentacion = async (codigo: string, subcodigo:string) => {
    return axios.get(`api/presentaciones/ConsultarParametrosPresentacion?codigo=${codigo}&subcodigo${subcodigo}`)
}
  
export const presentarPresentacion = async (postData: any) => {
    return axios.post('api/presentaciones/PresentarPresentacion',postData)
    .catch(err => err);
}

export const anularPresentacion = async (preCupon: any) => {
    let data = {PreCupon: preCupon,};
    return axios.post('api/presentaciones/AnularPresentacion',data)
}

 export const HavePermissionOCR = async () => {
    return axios.get(`api/presentaciones/HavePermissionOCR`)
      .catch(err => err);
  }